import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/adminService';
import './styles/SessionTimeout.css';

const SessionTimeout: React.FC = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    authService.clearToken();
    navigate('/admin/login');
  }, [navigate]);

  useEffect(() => {
    // Check session every minute
    const interval = setInterval(() => {
      const remainingSeconds = authService.getRemainingSessionTime();
      const minutes = Math.floor(remainingSeconds / 60);
      
      // Show warning if less than 10 minutes remaining
      if (remainingSeconds > 0 && remainingSeconds < 600) {
        setShowWarning(true);
        setRemainingMinutes(minutes);
      } else if (remainingSeconds === 0) {
        // Session expired
        handleLogout();
      } else {
        setShowWarning(false);
      }
    }, 60000); // Check every minute

    // Initial check
    const remainingSeconds = authService.getRemainingSessionTime();
    if (remainingSeconds === 0) {
      handleLogout();
    }

    return () => clearInterval(interval);
  }, [handleLogout]);

  if (!showWarning) return null;

  return (
    <div className="session-timeout-warning">
      <svg className="warning-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>
        Your session will expire in <strong>{remainingMinutes} minute{remainingMinutes !== 1 ? 's' : ''}</strong>. 
        Save your work!
      </span>
    </div>
  );
};

export default SessionTimeout;